module.exports = __webpack_public_path__ + "components/rewards/bird-eyewear/static/logo-b46bef531dc1b305cc78e4fa45dcfde3.jpg";